export const PRODUCTSEGMENT_TYPE_HIERARCHY = { id: 2, name: 'Hierarchy' };
export const PRODUCTSEGMENT_TYPE_HIERARCHY_FREE = {
  id: 4,
  name: 'HierarchyFree',
};
